import styled from 'styled-components';
import { Body2, spacing, colors, smallShadow, H3 } from 'ui/theme';
import { PrimaryButton } from 'ui/button';
import { ModalHeader, ModalFooter, ModalBody } from 'ui/modal';
import { Tooltip } from 'ui/tooltip';

export const StyledGradientHeader = styled(H3)`
  background: linear-gradient(
    218deg,
    #ff4d80 4.8%,
    #fe4d81 10.83%,
    #fc4e82 16.85%,
    #f95086 22.88%,
    #f4528a 28.91%,
    #ee5490 34.93%,
    #e65897 40.96%,
    #de5b9f 46.99%,
    #d65fa7 53.01%,
    #ce62af 59.04%,
    #c666b6 65.07%,
    #c068bc 71.09%,
    #bb6ac0 77.12%,
    #b86cc4 83.15%,
    #b66dc5 89.17%,
    #b56dc6 95.2%
  );
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
`;

export const StyledModalHeader = styled(ModalHeader)`
  background-color: rgb(254 252 255 / 0.9);
  border-bottom: ${spacing.single} solid ${colors.grey5};
  display: flex;
  align-items: flex-start;
  padding: ${spacing.plusHalf} ${spacing.double};
`;

export const StyledModalBodyWrapper = styled(ModalBody)`
  display: flex;
  gap: 20px;
  flex-direction: column;
  padding: ${spacing.plusHalf} ${spacing.double};
`;

export const StyledLightningPreHeader = styled.div`
  padding-bottom: 2.5px;
`;

export const StyledReengagementModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.threeQuarter};
`;

export const StyledReengagementModalFooter = styled(ModalFooter)`
  ${smallShadow}
  display: inline;
  width: 100%;
`;

export const StyledCampaignCreateButton = styled(PrimaryButton)`
  width: 100%;
`;

export const StyledTooltip = styled(Tooltip)`
  width: 100%;
`;

export const StyledNextBestAction = styled(Body2)`
  display: flex;
  align-items: center;
  color: ${colors.textSecondary};
  gap: 5px;
`;
